/**
 * Footer newsletter — progressive enhancement.
 *
 * Without JS the form posts to admin-post.php and the page reloads with
 * ?newsletter=ok|error (see App\Http\NewsletterSubscribe). With JS we submit to
 * data-ajax-url (admin-ajax.php, action crc_newsletter_subscribe) and show the
 * message in place — no reload, so the visitor stays on the footer.
 */
export default class Newsletter {
  static init() {
    document.querySelectorAll('form[data-newsletter]').forEach((form) => {
      new Newsletter(form);
    });
  }

  constructor(form) {
    this.form = form;
    this.url = form.dataset.ajaxUrl;

    // No endpoint -> leave the native admin-post.php submit (reload) untouched.
    if (!this.url) {
      return;
    }

    this.button = form.querySelector('button[type="submit"]');

    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  async onSubmit(event) {
    event.preventDefault();

    this.button?.setAttribute('disabled', 'disabled');

    try {
      const response = await fetch(this.url, {
        method: 'POST',
        body: new FormData(this.form), // carries action, _wpnonce, newsletter_email
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const payload = await response.json();

      const ok = payload?.success === true;
      this.showMessage(payload?.data?.message ?? '', ok);

      if (ok) {
        this.form.reset();
      }
    } catch (error) {
      this.showMessage('', false);
    } finally {
      this.button?.removeAttribute('disabled');
    }
  }

  /**
   * Reuses the same element and ok/error classes the Twig renders on reload, so
   * the existing message styling applies. Creates it on first AJAX submit.
   */
  showMessage(text, ok) {
    let message = this.form.querySelector('.site-footer__newsletter-message');

    if (!message) {
      message = document.createElement('p');
      message.className = 'site-footer__newsletter-message';
      message.setAttribute('role', 'status');
      this.form.appendChild(message);
    }

    message.textContent = text;
    message.classList.toggle('ok', ok);
    message.classList.toggle('error', !ok);
  }
}
